import React, {useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import api from '../contexts/BaseUrl';
import './ResetPassword.css'
import {Spinner} from 'react-activity'
import "react-activity/dist/Spinner.css";
import { FaEyeSlash, FaEye } from "react-icons/fa";

export default function ResetPassword(){

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    const token = searchParams.get('token');

     //login field params
     const [eyeOn, setEyeOn] = useState(false);
     const [passwordtype, setPasswordtype] = useState('password');

    const [resetPassword, setResetPassword] = useState(0);
    const [newPassword, setNewPassword] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);


    const handleEyeOnClick = () => {
        setEyeOn(true);
        setPasswordtype('text');
    }

    const handleEyeOffClick = () => {
        setEyeOn(false);
        setPasswordtype('password');
    }

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await api.post(`accounts/reset-staff-password`,{
            email: email,
            token: token,
            password: newPassword,
            confirmPassword: newPassword
        },{
            headers:{"Content-Type" : "application/json"}
        }).then(response => {
            setNewPassword('')
            setIsLoading(false);
            setResetPassword(1);
        }).catch(err => {
            setIsError(true);
            setIsLoading(false);
        })
    }

    return(
        <div className='resetPassword'>
            {resetPassword === 0 ?
            <div id='container' style={isError ? {height: 350}:{}}>
                <form id='containerBox' onSubmit={handleResetPassword}>
                    <div id='header'>Reset Password</div>
                    <div id='emailBox'>
                        <div id='emailHeader'>Email:</div>
                        <div id='emailDetails'>{email}</div>
                    </div>
                    <div id='emailHeader'>New Password:</div>
                    <div id='passwordBox'>
                        <input
                            id='inputBoxPassword'
                            type={passwordtype}
                            required
                            placeholder='Type your password...'
                            onChange={(e) => setNewPassword(e.target.value)}
                            value={newPassword}
                        />
                        {!eyeOn ?
                            <FaEyeSlash 
                                id='eye' 
                                onClick={handleEyeOnClick} 
                            /> 
                                : 
                            <FaEye  
                                id='eye' 
                                onClick={handleEyeOffClick}
                            />  
                        }
                        
                    </div>
                    {isError && <div id='errorMsg'>Failed to change password! Try again later.</div>}
                    {isLoading ? 
                        <button id='loginButton'><Spinner size={12} color = "white" style={{display:"block", margin:'auto'}} /></button> :
                        <button id='loginButton'>Change Password</button>
                    }
                   
                    <div id='login' onClick={() => navigate('/')} >Want to Login?</div>
                </form>
            </div>
            :
            <div id ='containerSuccess'>
                <div id='successDetails'>Password has been reset successfully.<br /> Please Login</div>
                <div id='login' onClick={() => navigate('/')} >Want to Login?</div>
            </div>
            }
        </div>
    )
}